function shouldRetryProcessing(issue) {
  const lastEdited = issue.llm_meta?.last_edited;
  if (!lastEdited) {
    return false;
  }
  return Date.now() - new Date(lastEdited).getTime() > 5 * 60 * 1000;
}

function isLlmIssue(issue) {
  return issue.llm_meta && issue.llm_meta.is_prod_issue;
}

export function isLlmIssueProcessing(issue) {
  return (
    isLlmIssue(issue) &&
    !issue.llm_meta.is_complete &&
    !issue.llm_meta.has_failed &&
    !shouldRetryProcessing(issue)
  );
}

export function hasLlmIssuePartialResults(issue) {
  return isLlmIssueProcessing(issue) && Boolean(issue.llm_response?.rag_state);
}

export function hasLlmIssueFailed(issue) {
  return (
    isLlmIssue(issue) &&
    (issue.llm_meta.has_failed ||
      (!issue.llm_meta.is_complete &&
        !issue.llm_meta.has_failed &&
        shouldRetryProcessing(issue)))
  );
}
